export default "__VITE_ASSET__BNRq1NnP__"